import { api } from '../lib/api'

export type ProService = {
  id: number
  name: string
  duration_minutes: number
  price_pixe: number
  capacity: number
  is_active: boolean
}

export async function listProServices() {
  const { data } = await api.get<{ results: ProService[] }>('/api/pros/services/')
  return Array.isArray(data?.results) ? data.results : []
}

export async function createProService(payload: Omit<ProService, 'id'>) {
  const { data } = await api.post<ProService>('/api/pros/services/', payload)
  return data
}

export async function updateProService(serviceId: number, payload: Partial<Omit<ProService, 'id'>>) {
  const { data } = await api.patch<ProService>(`/api/pros/services/${serviceId}/`, payload)
  return data
}

export async function deleteProService(serviceId: number) {
  await api.delete(`/api/pros/services/${serviceId}/`)
}

